import React, { useState } from 'react';
import { Button, message, Modal, Upload } from 'antd';
import { CameraOutlined, UploadOutlined } from '@ant-design/icons';
import { useParams } from 'react-router-dom';
import { useDocument } from '../../context/documentInfoContex';
import { templateService } from '../../api';
import './TemplateThumbnail.css';

const TemplateThumbnail = () => {
  const { id } = useParams();
  const { isTemplateDocument, templateData, setTemplateData, setSavingData } = useDocument();
  const docID = id;
  const [previewUrl, setPreviewUrl] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [customUrl, setCustomUrl] = useState(null);

  const handleOpenModal = () => {
    setIsModalVisible(true);
    // Capture the current view immediately
    handleCapture();
  };

  const handleCapture = async () => {
    try {
      // Find the canvas
      const canvas = document.querySelector('.canvas-container canvas');
      if (!canvas) {
        message.error('Canvas not found');
        return;
      }

      // Get the data URL from the canvas
      const thumbnailDataUrl = canvas.toDataURL('image/png');
      setPreviewUrl(thumbnailDataUrl);
    } catch (error) {
      message.error('Failed to capture thumbnail');
    }
  };

  const handleConfirmUpdate = async () => {
    try {
      const thumbnailUrl = customUrl || previewUrl;
      const res = await templateService.updateTemplate({ templateId: docID, data: { thumbnail: thumbnailUrl, docType: 'mileboard' }, dispatch: setSavingData });
      message.success('Thumbnail saved successfully');
      setIsModalVisible(false);
      setPreviewUrl(null);
      setCustomUrl(null);
      // Update templateData
      if (res?.data?.data) {
        setTemplateData(res.data.data);
      }
    } catch (error) {
      message.error('Failed to save thumbnail');
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setPreviewUrl(null);
    setCustomUrl(null);
  };

  const handleUpload = (info) => {
    const file = info.file;
    if (file) {
      // Check file size (1 MB limit)
      const maxSize = 1 * 1024 * 1024; // 1 MB in bytes
      if (file.size > maxSize) {
        message.error('File size must be less than 1 MB');
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        setCustomUrl(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  if (!isTemplateDocument) return null;

  return (
    <>
      <Button
        type="text"
        icon={<CameraOutlined className="thumbnail-button-icon" />}
        onClick={handleOpenModal}
        title="Save Thumbnail"
        size="small"
        className="thumbnail-button"
      />
      <Modal
        title={<div className="thumbnail-modal-header"><CameraOutlined className="thumbnail-modal-icon" />Thumbnail Preview</div>}
        visible={isModalVisible}
        onCancel={handleCancel}
        className="thumbnail-modal"
        width={560}
        footer={[
          <Button key="cancel" onClick={handleCancel} className="cancel-btn">
            Cancel
          </Button>,
          <Button key="save" type="primary" onClick={handleConfirmUpdate} className="update-thumbnail-btn">
            Save Thumbnail
          </Button>,
        ]}
      >
        <div className="thumbnail-content">
          <div className="thumbnail-preview-container" role="img" aria-label="thumbnail-preview">
            {(customUrl || previewUrl) ? (
              <img src={customUrl || previewUrl} alt="Thumbnail Preview" className="thumbnail-preview" />
            ) : (
              <div className="thumbnail-placeholder">
                <div className="placeholder-icon">📄</div>
                <p>No thumbnail yet</p>
              </div>
            )}
          </div>
          <div className="upload-section">
            <div className="upload-label">Upload a custom thumbnail</div>
            <Upload
              beforeUpload={() => false}
              onChange={handleUpload}
              showUploadList={false}
              accept="image/*"
            >
              <Button icon={<UploadOutlined />} className="upload-btn">Upload Custom Thumbnail</Button>
            </Upload>
            <div className="capture-label">Capture current view</div>
            <Button icon={<CameraOutlined />} onClick={handleCapture} className="capture-btn">
              Capture Current View
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default TemplateThumbnail;